import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';
import { contactForm } from "./contact-form";
import { recaptchaObject } from "./recaptcha";
import { bookingFormCommon } from './c005-bookingform-common';
import * as Cookies from 'js-cookie';
import 'jsPDF';

require('parsley');

export class reservationForm {
	private formEl:any = $('#reservation-form');
	private contactBase:any = new contactForm();

	/**
	 * initialize all form inputs with focus and filled effects
	 * @return {any} [description]
	 */
	initTextInputs():any {
		let _self = this;
		let inputElArr:any = _self.formEl.find('input[type="text"], input[type="email"], textarea');

		_self.contactBase.initFormTextInputs(inputElArr);
	}

	/**
	 * [initSelectizeInputs description]
	 * @return {any} [description]
	 */
	initSelectizeInputs(): any {
		let _self = this;
		let inputSelectArr:any = $.makeArray(_self.formEl.find('select'));
		_self.contactBase.initSelectizeInputs(inputSelectArr);
	}

	validateForm(): any {
		let _self = this;
		let alphaNumericPattern = /^([a-zA-Z0-9_]+)$/;
		let refTicketNoInvalid:any = false;
		let formUploadValidFileCount:any = 0;
		var fileExtension = ["jpg", "jpeg", "tiff", "png","gif", "bmp","pdf"];

		_self.contactBase.validateForm(_self.formEl, function(validation: any) {
			// all your custom validation here
		},
		function(validation:any, formData:Array<any>) {
			let _self: any = this;
			let $reservationForm:any   = $('#reservation-form');
			let fileInputs:any = $reservationForm.find('input[type="file"]');

			if (fileInputs.length) {
				fileInputs.each(function(){
					let fileEl:any = $(this);
					formData.push({
						"name": fileEl[0].getAttribute('id'),
						"value": fileEl[0].files
					});
				});
			}

			if (!formUploadValidFileCount) {
				formUploadValidFileCount = 0;
			}
			let htmlFormData:any = new FormData(validation.$element[0]);
			let bcommon: any = new bookingFormCommon();

			if (!refTicketNoInvalid && (formUploadValidFileCount < 1)) {
				bcommon.preloader();
				$.ajax({
					type: 'POST',
					url:'/bin/services/new/ReservationGSTFormServlet',
					data: htmlFormData,
					success: function(msg:any) {
						var redirectURL;
						if (msg.successCode == "200") {

							let reservationRefNo=msg.caseId;
							let	reservationUserName=msg.userName;
							Cookies.set('reservation-thank-you-flag', 'true');
							Cookies.set('reservation-RefNo', reservationRefNo);
							Cookies.set('reservation-UserName', reservationUserName);
							redirectURL = $(".reservation-forms").attr("data-supplementry-form-success");
						} else {
							redirectURL = $(".reservation-forms").attr("data-supplementry-form-fail");
						}
						document.querySelector('.contact-form--container').scrollIntoView(true);
						setTimeout(() => {
							window.scrollBy(0,-40);
						}, 800);
						bcommon.preloaderClose();
						window.location.href = redirectURL;
					},
					error: function(error:any) {
						bcommon.preloaderClose();
					},
					cache: false,
					contentType: false,
					processData: false,
				});
			}			
		});

		$('.alphanum-validator').off('keyup').on('keyup',function (e:any) {
			if (this.value.match(/[^a-zA-Z0-9 ]/g)) {
				this.value = this.value.replace(/[^a-zA-Z0-9 ]/g, '');
			}
		});

		$('.refnoticketnumber-validator').off('keyup').on('keyup',function (e:any) {
			$('#contact-reservation--refno--error-container').hide();
			refTicketNoInvalid = false;
			if (this.value.length < 7) {
				if (alphaNumericPattern.test(this.value.replace('-', '')) && isNaN(this.value.replace('-', ''))) {
					this.value = this.value.replace(/[^a-zA-Z0-9 ]/g, '');
					if (this.value.length && this.value.length < 6) {
						$('#contact-reservation--refno--error-container').show();
						refTicketNoInvalid = true;
					} else {
						$('#contact-reservation--refno--error-container').hide();
						refTicketNoInvalid = false;
					}
				} else if (this.value.length) {
					$('#contact-reservation--refno--error-container').show();
					refTicketNoInvalid = true;
				}
			} else if (this.value.length > 6 && e.keyCode != 37 && e.keyCode != 39) {
				if (isNaN(this.value.replace('-', ''))) {
					this.value = this.value.substring(0, 6);
					if (this.value.length == 6) {
						$('#contact-reservation--refno--error-container').hide();
						refTicketNoInvalid = false;
					}
				} else if (!isNaN(this.value.replace('-', ''))) {
					this.value = this.value.replace(/[^0-9 ]/g, '');
					this.value = this.value.replace(/./g, function(v, i) {
						return i === 2 ? v + "-" : v;
					});
					if (this.value.length == 14)  {
						$('#contact-reservation--refno--error-container').hide();
						refTicketNoInvalid = false;
					} else {
						$('#contact-reservation--refno--error-container').show();
						refTicketNoInvalid = true;
					}
				}
			}
		});

		$(document.body).on('change', '#reservation-files-upload' ,function() {
			var fsize = $(this)[0].files.item(0).size;
			if ((parseFloat((fsize / (1024*1024)).toFixed(2)) >= 5) || (fileExtension.indexOf($(this)[0].files.item(0).name.split('.').pop().toLowerCase()) < 0)) {
				$(this).addClass('error-validation');
				formUploadValidFileCount = formUploadValidFileCount + 1;
				
			} else {
				$(this).removeClass('error-validation');
				formUploadValidFileCount = (formUploadValidFileCount > 0) ? (formUploadValidFileCount - 1) : 0;
			}

			if ((parseFloat((fsize / (1024*1024)).toFixed(2)) >= 5)) {
				$('#file-upload--error-container').show();
			} else {
				$('#file-upload--error-container').hide();
			}
		});
	}

	/**
	 * [initDatepickerInputs description]
	 * @return {any} [description]
	 */
	initDatepickerInputs(): any {
		let _self = this;
		let inputDateArr   = $('#contact-reservation--flightdate');
		let minDate:any = new Date();
		let maxDate:any = new Date((new Date().getFullYear() + 5).toString());

		_self.contactBase.initDatepickerInputs(inputDateArr, minDate, maxDate);
	}

	initFileUpload():any {
		let _self = this;
		var $fileId = $('#newFile');
		var $fileUploadRow = $('.contact--documents-upload .fileInput');

		$fileId.click(function (e: any) {
			e.preventDefault();
			e.stopPropagation();

			if ($fileUploadRow.find(".contact--file-upload").length < 4) { 
				$('<div class="col-lg-6 col-md-6 col-sm-6 contact--file-upload"><label class="booking-form--title hidden" for="reservation-files-upload">File</label><input id="reservation-files-upload" type="file" name="file_upload[]"></div>').insertAfter(".contact--file-upload:last");
			}

			if ($fileUploadRow.find(".contact--file-upload").length == 4) {
				$fileId.hide();
			}
		});
	}

	initPrintBtn(): any {
		let _self = this;
		let printBtn = _self.formEl.find('#reservation-download-btn');
		printBtn.click((e:any) => {
			e.preventDefault();
			e.stopPropagation();
			
			let pdf = new jsPDF('p','pt','a4');
			var specialElementHandlers = {
				'#editor': function (element:any, renderer:any) {
					return true;
				}
			};

			pdf.fromHTML($('#reservation-download-content').html(), 15, 15, {
				'width': 500,
				'elementHandlers': specialElementHandlers
			});
			pdf.save('WF' + ($('.reservationRefNo').text()) + ' - ' + ($('#reservation-category-val').val()) + '.pdf');
		});
	}

	initRecaptcha():any {
		let _self = this;
		let recaptchaobj = new recaptchaObject();

		let recaptchaInfo:recaptchaInfo = {
			id: 'register-form-reservation-recaptcha',
			cb: 'recaptchaRegistrationSuccess',
			cbObj: 	function (response:any) {
								(document.getElementById('register-form-reservation-recaptcha') as HTMLInputElement).value = 'true';
							},
			displayId: 'contact-reservation--grecaptcha',
			formEl: _self.formEl
		};

		recaptchaobj.createRecaptchaField(recaptchaInfo);
	}
}

let thankScope:Element = document.querySelector('.reservation-thank-you');
if(thankScope){
	if (Cookies.get('reservation-thank-you-flag') == 'true') {
		$('.reservationRefNo').text(Cookies.get('reservation-RefNo'));
		$('.reservationUserName').text(Cookies.get('reservation-UserName'));
		let reservationform = new reservationForm();
		reservationform.initPrintBtn();
	}
	else
	{
		var redirectURL;
		redirectURL = $(".reservation-thank-you").attr("data-supplementry-form-expiry");
		window.location.href = redirectURL;
	}
}

let scope:Element = document.querySelector('.reservation-forms');
if (scope){
	try {
	let reservationform = new reservationForm();
		reservationform.initTextInputs();
		reservationform.initSelectizeInputs();
		reservationform.initDatepickerInputs();
		reservationform.validateForm();
		reservationform.initFileUpload();
		reservationform.initPrintBtn();
		reservationform.initRecaptcha();
		let $china_form: any = $('#china_form');
		if (($china_form.val() =='yes'))
		{
			$('#register-form-reservation-recaptcha').remove();
			let security_head=$('#reservation-form h5')[6];
			security_head.remove();
		}
		$("#contact-reservation-form-submit-theIframe").on('click',function() {
      var jForm =$(".feedback_form");var jFeedbackFormWrapper = jForm.closest(".feedback_form_wrapper");
      var win = <HTMLIFrameElement>document.getElementById('theIframe');
        win.contentWindow.postMessage('submit', '*');
        $("#theIframe").on("load", function () {
            $(window).scrollTop(1000);
            $("#contact-form-lava-product").hide();
            $(".contact-iframe-booking--success").show();
        })
    });
	} catch(e) {console.error(e);}
}
